import Loadable from '../../components/loadable';

const RecentActivity = Loadable({
  loader: () => import('../../pages/dashboard/recent_activity'),
  type: 'block',
});

angular.module('gym').value('RecentActivity', RecentActivity);
